<div class="page-content container">
    <h4 class="text-lg text-center font-weight-bold">Track My Request</h4>
    <br>
    <div class="row  request-meta">
        <div class="col-6">
            <div class="reference_number">
                CBM202104123456
            </div>
            <div>
                <div class="label">Status</div>
                <div class="status">
                    For CBM Acceptance
                </div>
            </div>
        </div>
        <div class="col-6 d-flex flex-column justify-content-center">
            <div class="label">CBM Name</div>
            <div>Alfredo G. Crisostomo Electrical Contractor</div>
        </div>
    </div>
    <br>
    <div class="row detail-group">
        General Information
    </div>
    <br>
    <div class="row" >
        <div class="col-3 clear" >
            <div class="detail-box">
                <div class="label">CXE Case Number</div>
                <div>12345678901</div>
            </div>
            <div class="detail-box">
                <div class="label">Service Type</div>
                <div>Service Entrance Installation</div>
            </div>
            <div class="detail-box">
                <div class="label">Multi-meter Tag</div>
                <div>Single</div>
            </div>
        </div>
        <div class="col-3 clear" >
            <div class="detail-box">
                <div class="label">Assigned Meralco Personnel</div>
                <div>Fernando Amorsolo</div>
                <div>Makati BC</div>
            </div>
            <div class="detail-box">
                <div class="label">Service Bundle</div>
                <div>Complete Bundle</div>
            </div>
            <div class="detail-box">
                <div class="label">Category</div>
                <div>Residential</div>
            </div>
        </div>
        <div class="col-3 clear">
            <div class="detail-box">
                <div class="label">Estimated Cost</div>
                <div>Php 0.00</div>
            </div>
        </div>
        <div class="col-3 clear"></div>
    </div>
    <br>
    <div class="row detail-group">
        Customer Information
    </div>
    <br>
    <div class="row">
        <div class="col-3 clear">
            <div class="detail-box">
                <div class="label">Customer Name</div>
                <div>Juan Santos Dela Cruz Jr.</div>
            </div>
            <div class="detail-box">
                <div class="label">Primary Mobile</div>
                <div>+63 *** *** 7890</div>
            </div>
        </div>
        <div class="col-3 clear">
            <div class="detail-box">
                <div class="label">Date of Birth</div>
                <div>03/19/1985</div>
            </div>
            <div class="detail-box">
                <div class="label">Primary Phone</div>
                <div>+63 *** *** 7890</div>
            </div>
        </div>
        <div class="col-3 clear">
            <div class="detail-box">
                <div class="label">Primary Email</div>
                <div>m***&#64;e****.***</div>
            </div>
        </div>
        <div class="col-3 clear">
            <div class="detail-box">
                <div class="label">Preferred Notification Channel</div>
                <div>SMS & Email</div>
            </div>
        </div>
    </div>
    <br>
    <div class="row detail-group">
        Service Address Information
    </div>
    <br>
    <div class="row">
        <div class="col-6 clear">
            <div class="detail-box">
                <div class="label">Address</div>
                <div>114 Kundiman Street, San Isidro, Cainta, Metro Manila</div>
            </div>
            <div class="detail-box">
                <div class="label">Landmark</div>
                <div>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor.</div>
            </div>
        </div>
    </div>
    <br>
    <div class="row detail-group">
        Service Information
    </div>
    <br>
    <div class="row">
        <div class="col-6 clear">
            <div class="detail-box">
                <div class="label">Applied Load</div>
                <div>1.5kW</div>
            </div>
        </div>
    </div>
    <br>
    <br>
    <br>
</div>
